// router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import PrintHome from '../views/PrintHome.vue'
import MyOrders from '../views/MyOrders.vue'
import AllOrders from '../views/AllOrders.vue'
import PrintInvoice from '../views/PrintInvoice.vue'
import PriceManage from '../views/PriceManage.vue'
import UserCenter from '../views/UserCenter.vue';
import CouponManage from '../views/CouponManage.vue';
import UserManage from '../views/UserManage.vue';
import InvoiceManage from '../views/InvoiceManage.vue';
import PoorApplications from '../views/PoorApplications.vue'
import PriceIntro from '../views/PriceIntro.vue'
import XiaoneiOrders from '../views/XiaoneiOrders.vue'



const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/Home',
    name: 'PrintHome',
    component: PrintHome
  },
  {
    path: '/my-orders',
    name: 'MyOrders',
    component: MyOrders
  },
  {
    path: '/all-orders',
    name: 'AllOrders',
    component: AllOrders
  },
  {
    path: '/invoice',
    name: 'PrintInvoice',
    component: PrintInvoice
  },
  {
    path: '/price-manage',
    name: 'PriceManage',
    component: PriceManage
  },
  {
    path: '/user-center',
    name: 'UserCenter',
    component: UserCenter,
    meta: {
      requiresAuth: true,
      adminOnly: false
    }
  },
  {
    path: '/coupon-manage',
    name: 'CouponManage',
    component: CouponManage,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/user-manage',
    name: 'UserManage',
    component: UserManage,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/invoice-manage',
    name: 'InvoiceManage',
    component: InvoiceManage,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/poor-applications',
    name: 'PoorApplications',
    component: PoorApplications,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/price',
    name: 'PriceIntro',
    component: PriceIntro,
  },
  {
    path: '/xiaonei-orders',
    name: 'XiaoneiOrders',
    component: XiaoneiOrders,
    meta: {
      requiresAuth: true,
      adminOnly: false
    }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router

router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem("userName") // 检查是否登录
  const isAdmin = localStorage.getItem("isAdmin") === 'true' // 确保转换为布尔值
  const isXiaoneiUser = localStorage.getItem("isXiaoneiUser") === 'true' // 小内管理员标识

  // 如果用户已登录但尝试访问登录页，重定向到登录页
  if (to.name === 'Login' && isAuthenticated) {
    if (isXiaoneiUser) {
      next({ name: 'XiaoneiOrders' })
    } else {
      next({ name: isAdmin ? 'AllOrders' : 'PrintHome' })
    }
    return
  }

  // 小内管理员只能访问 xiaonei-orders 页面
  if (isXiaoneiUser) {
    if (to.name !== 'XiaoneiOrders') {
      next({ name: 'XiaoneiOrders' })
      return
    }
  }

  // 如果路由需要认证但用户未登录
  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'Login' })
    return
  }

  // 如果路由需要管理员权限但用户不是管理员
  if (to.meta.adminOnly && !isAdmin) {
    next({ name: 'PrintHome' })
    return
  }

  // 管理员不能访问 PrintHome 和 MyOrders
  if (isAdmin && (to.name === 'MyOrders')) {
    next({ name: 'AllOrders' }) // 重定向到管理员默认页
    return
  }

  // 普通用户不能访问管理员专属页面
  if (!isAdmin && to.meta.adminOnly) {
    next({ name: 'PrintHome' })
    return
  }

  next() // 放行
})